import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/buildhome/repo/src/components/docs-layout.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "wireless-keyboard-firmware"
    }}>{`Wireless Keyboard Firmware`}</h1>
    <p>{`Firmware is an extremely important part of a keyboard. Custom wireless keyboards are still in infancy, so firmwares (while very much usable!) are still heavily being worked on. You may be wondering "why isn't it supported in QMK?". You can read why `}<a parentName="p" {...{
        "href": "/docs/nice-nano/faq/#qmk-firmware-support"
      }}>{`here`}</a>{`.`}</p>
    <h2 {...{
      "id": "options"
    }}>{`Options`}</h2>
    <ul>
      <li parentName="ul">
        <h3 parentName="li" {...{
          "id": "zmk---recommended"
        }}><a parentName="h3" {...{
            "href": "/docs/wireless-firmware/zmk"
          }}>{`ZMK`}</a>{` - Recommended`}</h3>
        <ul parentName="li">
          <li parentName="ul">{`ZMK is an extremely promising firmware with a wireless first approach and permissive licensing`}</li>
          <li parentName="ul">{`Pros:`}
            <ul parentName="li">
              <li parentName="ul">{`Well designed board system leveraging Zephyr RTOS`}</li>
              <li parentName="ul">{`Best-in-class power usage`}</li>
              <li parentName="ul">{`Extremely easy to set up with no local build environment required`}</li>
              <li parentName="ul">{`Supports much more than just the nRF52 including many ARM wired keyboards`}</li>
              <li parentName="ul">{`USB support`}</li>
            </ul>
          </li>
          <li parentName="ul">{`Cons`}
            <ul parentName="li">
              <li parentName="ul">{`Understanding the board system may take some time for those used to other firmwares`}</li>
            </ul>
          </li>
        </ul>
      </li>
      <li parentName="ul">
        <h3 parentName="li" {...{
          "id": "bluemicro---recommended"
        }}><a parentName="h3" {...{
            "href": "/docs/wireless-firmware/bluemicro"
          }}>{`BlueMicro`}</a>{` - Recommended`}</h3>
        <ul parentName="li">
          <li parentName="ul">{`BlueMicro is an easy to set up firmware for nRF52 chips utilizing Arduino`}</li>
          <li parentName="ul">{`Pros:`}
            <ul parentName="li">
              <li parentName="ul">{`Based on Arduino, which some may be familiar with`}</li>
              <li parentName="ul">{`Reliable wireless connection between halves`}</li>
            </ul>
          </li>
          <li parentName="ul">{`Cons:`}
            <ul parentName="li">
              <li parentName="ul">{`No USB support`}</li>
              <li parentName="ul">{`Higher power usage`}</li>
              <li parentName="ul">{`Locked into the nRF52 ecosystem`}</li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      